export function createConversationClient(apiBase, token, transport = fetch) {
  const cache = new Map();
  // Vercel strips CORS headers from conditional 304 responses. Cross-origin
  // inbox polls must get a fresh 200 instead of relying on browser revalidation.
  const conditionalReads = typeof window !== 'undefined' && new URL(apiBase, window.location.href).origin === window.location.origin;
  return async (path, { signal, body, key } = {}) => {
    const cached = conditionalReads && body === undefined && cache.get(path);
    const response = await transport(`${apiBase}/conversations/v2/${path}`, {
      method: body === undefined ? 'GET' : 'POST', signal,
      ...(body === undefined && !conditionalReads ? { cache: 'no-store' } : {}),
      headers: { Authorization: `Bearer ${token}`, ...(body === undefined ? {} : { 'Content-Type': 'application/json' }),
        ...(cached ? { 'If-None-Match': cached.etag } : {}), ...(key ? { 'Idempotency-Key': key } : {}) },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    });
    if (response.status === 304 && cached) return cached.data;
    const data = await response.json();
    if (!response.ok && !data.sendRequestId) throw Object.assign(new Error(data.message || 'Conversation request failed'), { status: response.status, code: data.code });
    if (response.ok && data.success === false && !data.sendRequestId) throw new Error(data.message || 'Conversation request failed');
    const etag = response.headers.get('ETag');
    if (conditionalReads && body === undefined && etag) { if (cache.size >= 128) cache.delete(cache.keys().next().value); cache.set(path, { data, etag }); }
    return data;
  };
}
export function mergeRows(oldRows, newRows, field = 'id') {
  const rows = new Map(oldRows.map(row => [row[field], row])); newRows.forEach(row => rows.set(row[field], row));
  return [...rows.values()].sort((a, b) => String(b.occurredAt || b.lastMessageAt).localeCompare(String(a.occurredAt || a.lastMessageAt)) || String(b[field]).localeCompare(String(a[field])));
}
export function tenantIdentity(token) {
  try { return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).userId || null; } catch (_) { return null; }
}
export function loadDraft(key) {
  try { const draft = JSON.parse(sessionStorage.getItem(key)); return draft && typeof draft.body === 'string' && Array.isArray(draft.media) ? draft : { body: '', media: [] }; }
  catch (_) { return { body: '', media: [] }; }
}
export function saveDraft(key, draft) { try { sessionStorage.setItem(key, JSON.stringify(draft)); } catch (_) { /* The in-memory draft remains available. */ } }
